module.exports = __webpack_public_path__ + "img/flamingo-icon.c873d3f3.svg";